import { gql } from '@apollo/client';

// @TODO Rework these logics using userV2 [WWW-11898]
const USER = gql`
  query User {
    user {
      id
      customer {
        id
        firstName
        lastName
        email
      }
    }
  }
`;

export default USER;
